/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import { apiDataToDropdownList } from "../../../utils/sysHelpers";
import SysTable from "../../commonComponents/SysTable";

class UserManagement extends Component {
  state = {
    data: {
      fullName: "",
      email: "",
      phoneNum: "",
      gender: "",
      birthday: "",
    },

    contentHeader: "Owners",
    addButtonLabel: "Add Owner",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetOwners",
    singleItemUrl: "/api/data/GetOwner",
    addUrl: "/api/data/AddOwner",
    editUrl: "/api/data/EditOwner",
    deleteUrl: "/api/data/DeleteOwner",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Owner",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Owner",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],

    allGender: [
      { label: "Male", value: "Male" },
      { label: "Female", value: "Female" },
    ],
  };

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["fullName"] = apiResponse.data.respData.data[0].FULL_NAME;
      data["email"] = apiResponse.data.respData.data[0].EMAIL;
      data["phoneNum"] = apiResponse.data.respData.data[0].PHONE_NUM;
      data["gender"] = apiResponse.data.respData.data[0].GENDER;
      data["birthday"] = apiResponse.data.respData.data[0].BIRTHDATE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  handleBlock(row) {
    post(
      "/api/data/BlockOwner",
      { id: row.ID },
      this.props.updateIsLoading
    ).then(() => this.getData());
  }

  handleUnblock(row) {
    post(
      "/api/data/UnblockOwner",
      { id: row.ID },
      this.props.updateIsLoading
    ).then(() => this.getData());
  }
  
  handleResetPassword(row) {
      confirmAlert({
        title: "Reset Password",
        message: "Please select the method you want to send the new password to the owner",
        buttons: [
          {
            label: "Email",
            onClick: () => {
              post(
                "/api/data/ResetOwnerPassword",
                { id: row.ID, type: "email" },
                this.props.updateIsLoading
              ).then((apiResponse) => {
                apiResponse.data.respCode === 0 ? this.getData() : null;
              });
            },
          },
          {
            label: "Phone Number",
            onClick: () => {
              post(
                "/api/data/ResetOwnerPassword",
                { id: row.ID, type: "phone number" },
                this.props.updateIsLoading
              ).then((apiResponse) => {
                apiResponse.data.respCode === 0 ? this.getData() : null;
              });
            },
          },
          { label: this.props.t("btn.cancel"),
            onClick: () => null,
          },
        ],
      });
    }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.ownerName"),
        field: "FULL_NAME",
      },
      {
        id: 2,
        label: t("col.email"),
        field: "EMAIL",
      },
      {
        id: 3,
        label: t("col.phone"),
        field: "PHONE_NUM",
      },
      {
        id: 4,
        label: t("col.blocked"),
        field: "IS_BLOCKED",
        cellRenderer: ({ data }) => {
          return data.IS_BLOCKED === "Y" ? "Yes" : "No";
        },
      },
      {
        id: 5,
        label: t("col.active"),
        field: "IS_ACTIVE",
        cellRenderer: ({ data }) => {
          return data.IS_ACTIVE === "Y" ? "Yes" : "No";
        },
      },
      {
        id: 6,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 7,
        label: t("col.lastLogin"),
        field: "LAST_LOGIN_DATE",
      },
      {
        id: 8,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "120px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB20"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB21"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB22"]) && (
                <div className="inner" title="Deactivate">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleBlock(data)}
                  >
                    <i className="fa fa-ban" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB23"]) && (
                <div className="inner" title="Activate">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleUnblock(data)}
                  >
                    <i className="fa fa-check" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB24"]) && (
                <div className="inner" title="Reset Password">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleResetPassword(data)}
                  >
                    <i className="fa fa-key" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.owners")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB1F"]) && (
              <Button
                label={t("pages.addOwner")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "fullName",
                label: t("col.ownerName"),
              },
              {
                type: "text",
                id: "email",
                label: t("col.email"),
                disabled: false,
              },
              {
                type: "text",
                id: "phoneNum",
                label: t("col.phone"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "gender",
                label: t("col.gender"),
                disabled: false,
                options: this.state.allGender,
              },
              {
                type: "text",
                id: "birthday",
                label: t("col.birthday"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(UserManagement);
